import React, { useState, useEffect } from "react";
import { getFirestore, collection, getDocs, doc, updateDoc, onSnapshot } from "firebase/firestore";
import app from "../../firebase";

export default function AssessmentFee() {
  const [students, setStudents] = useState([]);
  const [search, setSearch] = useState("");
  const [showPaid, setShowPaid] = useState(false);
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;
  const [actionMenu, setActionMenu] = useState(null); // {rowIdx: number} or null
  const [viewStudent, setViewStudent] = useState(null); // student object or null
  const [paymentStudent, setPaymentStudent] = useState(null); // student object or null
  const [amount, setAmount] = useState("");
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    if (!paymentStudent) return;
    const interval = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(interval);
  }, [paymentStudent]);

  useEffect(() => {
    const db = getFirestore(app);
    const studentsCol = collection(db, "students");
    const unsubscribe = onSnapshot(studentsCol, (snap) => {
      setStudents(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    }, (err) => {
      console.error("Error fetching students:", err);
    });
    return unsubscribe;
  }, []);

  // Filter and paginate
  const filtered = students.filter(s => {
    const matchesSearch = s.idNumber?.toLowerCase().includes(search.toLowerCase()) ||
      `${s.firstName} ${s.lastName}`.toLowerCase().includes(search.toLowerCase());
    const isPaid = s.AssessmentFeeStatus === 'Paid';
    return matchesSearch && (showPaid ? isPaid : !isPaid);
  });
  const totalPages = Math.ceil(filtered.length / rowsPerPage);
  const paginated = filtered.slice((page - 1) * rowsPerPage, page * rowsPerPage);

  return (
    <div style={{ padding: 40, minHeight: "100vh", background: "#f5f5f5" }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
        <input
          type="text"
          placeholder="Search by ID or Name"
          value={search}
          onChange={e => { setSearch(e.target.value); setPage(1); }}
          style={{ width: 350, padding: 12, borderRadius: 4, border: '1px solid #888', fontSize: 18, background: '#7c857c22', marginRight: 24 }}
        />
        <button
          style={{ background: showPaid ? '#18803b' : '#d97d2c', color: '#fff', border: 'none', borderRadius: 6, padding: '12px 32px', fontWeight: 700, fontSize: 18, minWidth: 120, cursor: 'pointer' }}
          onClick={() => { setShowPaid(p => !p); setPage(1); }}
        >
          {showPaid ? 'Paid' : 'Unpaid'}
        </button>
      </div>
      <table style={{ width: "100%", background: "#fff", borderRadius: 8, boxShadow: "0 2px 8px rgba(0,0,0,0.06)", borderCollapse: "collapse", marginBottom: 24 }}>
        <thead>
          <tr style={{ background: "#e8e8e8" }}>
            <th style={{ padding: 12, textAlign: "left" }}>ID Number</th>
            <th style={{ padding: 12, textAlign: "left" }}>Name</th>
            <th style={{ padding: 12, textAlign: "left" }}>Date of Schedule</th>
            <th style={{ padding: 12, textAlign: "left" }}>Time of Schedule</th>
            <th style={{ padding: 12, textAlign: "left" }}>Status</th>
            <th style={{ padding: 12, textAlign: "left" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {paginated.length === 0 ? (
            <tr><td colSpan={6} style={{ textAlign: 'center', padding: 32 }}>No students found.</td></tr>
          ) : paginated.map((student, idx) => (
            <tr key={student.id} style={{ borderBottom: "1px solid #eee" }}>
              <td style={{ padding: 10 }}>{student.idNumber || 'EXAMPLE'}</td>
              <td style={{ padding: 10 }}>{student.lastName ? `${student.lastName}, ${student.firstName}` : 'EXAMPLE'}</td>
              <td style={{ padding: 10 }}>{student.appointment?.date || '2025-09-11'}</td>
              <td style={{ padding: 10 }}>{student.appointment?.time === 'am' ? 'AM 9:00-12:00' : student.appointment?.time === 'pm' ? 'PM 1:00-4:00' : 'AM 9:00-12:00'}</td>
              <td style={{ padding: 10 }}>
                  <span style={{ background: students.find(s => s.id === student.id)?.AssessmentFeeStatus === 'Paid' ? '#18803b' : '#d97d2c', color: '#fff', borderRadius: 4, padding: '4px 18px', fontWeight: 600 }}>
                    {students.find(s => s.id === student.id)?.AssessmentFeeStatus === 'Paid' ? 'Paid' : 'Unpaid'}
                  </span>
              </td>
              <td style={{ padding: 10, position: 'relative' }}>
                <button
                  style={{ background: 'none', border: 'none', fontSize: 22, padding: 0 }}
                  onClick={() => setActionMenu(actionMenu === idx ? null : idx)}
                >&#8942;</button>
                {actionMenu === idx && (
                  <div style={{ position: 'absolute', right: 0, top: 36, background: '#7c857c', color: '#fff', borderRadius: 6, boxShadow: '0 2px 8px rgba(0,0,0,0.13)', minWidth: 120, zIndex: 10 }}>
                    <div
                      style={{ padding: '12px 18px', borderBottom: '1px solid #eee', background: '#7c857c', cursor: 'pointer' }}
                      onClick={() => { setViewStudent(student); setActionMenu(null); }}
                    >View Profile</div>
                    <div
                      style={{ padding: '12px 18px', cursor: 'pointer', background: '#7c857c' }}
                      onClick={() => {
                        setPaymentStudent(student);
                        setActionMenu(null);
                        setAmount("");
                      }}
                    >Payment</div>
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {/* Assessment Fee Payment Modal */}
      {paymentStudent && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.35)', zIndex: 1000,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <div style={{ background: '#fff', borderRadius: 8, padding: '40px 48px', minWidth: 420, maxWidth: 480, width: '100%', boxShadow: '0 2px 16px rgba(0,0,0,0.13)', position: 'relative' }}>
            <h2 style={{ fontWeight: 700, fontSize: 24, marginBottom: 24, textAlign: 'center' }}>Assessment Fee</h2>
            <div style={{ fontSize: 17, lineHeight: 2, display: 'grid', gridTemplateColumns: '160px 1fr', gap: '0 16px', marginBottom: 24 }}>
              <div>Name:</div><div>{paymentStudent.lastName}, {paymentStudent.firstName}</div>
              <div>ID Number:</div><div>{paymentStudent.idNumber}</div>
              <div>Fee:</div><div>500 peso</div>
              <div>Payment:</div><div>Cash</div>
              <div>Amount:</div>
                <div>
                  <input
                    type="number"
                    min="0"
                    value={amount}
                    onChange={e => setAmount(e.target.value.replace(/[^0-9]/g, ""))}
                    style={{ width: 120, padding: 6, fontSize: 16, borderRadius: 4, border: '1px solid #ccc' }}
                    placeholder="0"
                  />
                </div>
              <div>Change:</div><div>{amount ? (parseInt(amount, 10) - 500 >= 0 ? (parseInt(amount, 10) - 500) : 0) : 0}</div>
              <div>Date and time</div><div>{now.toLocaleString('en-PH', { timeZone: 'Asia/Manila', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true })}</div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', gap: 24, marginTop: 32 }}>
              <button
                style={{ background: '#f5f5f5', color: '#18803b', border: 'none', borderRadius: 6, padding: '10px 32px', fontWeight: 600, fontSize: 18, cursor: 'pointer' }}
                onClick={async () => {
                  const db = getFirestore(app);
                  const studentRef = doc(db, 'students', paymentStudent.id);
                  const paymentData = {
                    AssessmentFeeStatus: 'Paid',
                    AssessmentFee: {
                      Fee: 500,
                      Payment: 'Cash',
                      Amount: amount ? parseInt(amount, 10) : 0,
                      Change: amount ? (parseInt(amount, 10) - 500 >= 0 ? (parseInt(amount, 10) - 500) : 0) : 0,
                      DateTime: now.toLocaleString('en-PH', { timeZone: 'Asia/Manila', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true })
                    }
                  };
                  await updateDoc(studentRef, paymentData);
                  setStudents(students => students.map(s => s.id === paymentStudent.id ? { ...s, AssessmentFeeStatus: 'Paid', AssessmentFee: paymentData.AssessmentFee } : s));
                  setPaymentStudent(null);
                }}
              >Print</button>
              <button
                style={{ background: '#fff', color: '#d97d2c', border: '1.5px solid #f3c7a6', borderRadius: 6, padding: '10px 32px', fontWeight: 700, fontSize: 18, cursor: 'pointer' }}
                onClick={() => setPaymentStudent(null)}
              >CLOSE</button>
            </div>
          </div>
        </div>
      )}
      {/* Student Details Modal */}
      {viewStudent && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.35)', zIndex: 1000,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <div style={{ background: '#fff', borderRadius: 8, padding: '40px 48px', minWidth: 420, maxWidth: 480, width: '100%', boxShadow: '0 2px 16px rgba(0,0,0,0.13)', position: 'relative' }}>
            <h2 style={{ fontWeight: 700, fontSize: 24, marginBottom: 24 }}>Student Details</h2>
            <div style={{ fontSize: 18, lineHeight: 1.7 }}>
              <b>Name:</b> {viewStudent.firstName} {viewStudent.lastName}<br />
              <b>Email:</b> {viewStudent.email}<br />
              <b>Category:</b> {viewStudent.category || 'N/A'}<br />
              <b>Program:</b> {viewStudent.program}<br />
              <b>Gender:</b> {viewStudent.gender || 'N/A'}<br />
              <b>Date of Birth:</b> {viewStudent.birthDate || 'N/A'}<br />
              <b>Mobile:</b> {viewStudent.mobile || 'N/A'}<br />
              <b>2x2 Picture:</b> {viewStudent.pictureUrl ? <a href={viewStudent.pictureUrl} target="_blank" rel="noopener noreferrer">View</a> : 'N/A'}<br />
              <b>Date of Schedule:</b> {viewStudent.appointment?.date || 'N/A'}<br />
              <b>Time of Schedule:</b> {viewStudent.appointment?.time === 'am' ? 'AM 9:00-12:00' : viewStudent.appointment?.time === 'pm' ? 'PM 1:30-4:30' : 'N/A'}
            </div>
            {viewStudent.AssessmentFeeStatus === 'Paid' && viewStudent.AssessmentFee && (
              <div style={{ fontSize: 18, lineHeight: 2, marginTop: 24, borderTop: '1px solid #eee', paddingTop: 18 }}>
                <b>Assessment Fee Payment Details</b><br />
                <b>Fee:</b> {viewStudent.AssessmentFee.Fee} peso<br />
                <b>Payment:</b> {viewStudent.AssessmentFee.Payment}<br />
                <b>Amount:</b> {viewStudent.AssessmentFee.Amount}<br />
                <b>Change:</b> {viewStudent.AssessmentFee.Change}<br />
                <b>Date and time:</b> {viewStudent.AssessmentFee.DateTime}
              </div>
            )}
            <button
              style={{ marginTop: 32, background: '#fff', color: '#d97d2c', border: '1.5px solid #f3c7a6', borderRadius: 6, padding: '10px 32px', fontWeight: 700, fontSize: 18, cursor: 'pointer', float: 'right' }}
              onClick={() => setViewStudent(null)}
            >CLOSE</button>
          </div>
        </div>
      )}
      {/* Pagination */}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8 }}>
        <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1} style={{ background: 'none', border: 'none', fontSize: 28, color: page === 1 ? '#ccc' : '#18803b', cursor: page === 1 ? 'not-allowed' : 'pointer' }}>&#8592;</button>
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            onClick={() => setPage(i + 1)}
            style={{ background: 'none', border: 'none', fontWeight: page === i + 1 ? 700 : 400, color: page === i + 1 ? '#d97d2c' : '#222', fontSize: 18, cursor: 'pointer', minWidth: 28 }}
          >{i + 1}</button>
        ))}
        <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages} style={{ background: 'none', border: 'none', fontSize: 28, color: page === totalPages ? '#ccc' : '#18803b', cursor: page === totalPages ? 'not-allowed' : 'pointer' }}>&#8594;</button>
      </div>
    </div>
  );
}
